import React, { useState, useEffect } from 'react';
import { AppProvider, useApp } from './contexts/AppContext';
import { JobSelector } from './components/JobSelector';
import { PracticeArea } from './components/PracticeArea';
import { loadJobs, getAvailableJobs } from './services/jobs';
import { Job } from './types';
import './App.css';

function AppContent() {
  const {setCurrentJob } = useApp();
  const [selectedJob, setSelectedJob] = useState<Job | null>(null);
  const [jobs, setJobs] = useState<Job[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initializeJobs = async () => {
      await loadJobs();
      setJobs(getAvailableJobs());
      setLoading(false);
    };
    initializeJobs();
  }, []);

  const handleJobSelect = (job: Job) => {
    setSelectedJob(job);
    setCurrentJob(job);
  };

  const handleBackToJobSelection = () => {
    setSelectedJob(null);
    setCurrentJob(null);
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontFamily: 'Arial, sans-serif'
      }}>
        加载中...
      </div>
    );
  }

  return (
    <div style={{ fontFamily: 'Arial, sans-serif' }}>
      {!selectedJob ? (
        <JobSelector 
          jobs={jobs} 
          onJobSelect={handleJobSelect} 
        />
      ) : (
        <PracticeArea onBackToJobSelection={handleBackToJobSelection} />
      )}
    </div>
  );
}

function App() {
  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
}

export default App;
